import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ShieldCheck, FileText, CheckCircle2 } from 'lucide-react';

const SUPPORT_EMAIL = 'Stockara@gmail.com';
const UPDATED_AT = '29 Mei 2026';

const termsSections = [
  {
    title: 'Ketentuan umum',
    body: [
      'Dengan mengakses website, membuat akun, atau menggunakan layanan Stockara, kamu menyetujui Syarat & Ketentuan ini. Jika kamu menggunakan Stockara atas nama bisnis atau organisasi, kamu menyatakan memiliki wewenang untuk menyetujui ketentuan ini.',
      'Stockara adalah platform bisnis berbasis cloud untuk membantu pengelolaan stok, kasir, laporan, channel penjualan, dan fitur AI. Layanan dapat berkembang dari waktu ke waktu sesuai kebutuhan produk dan pelanggan.',
    ],
  },
  {
    title: 'Akun dan akses',
    body: [
      'Kamu wajib memberikan data yang benar saat registrasi, menjaga keamanan email dan password, serta bertanggung jawab atas aktivitas yang terjadi di akunmu.',
      'Akses fitur dapat berbeda berdasarkan paket, role pengguna, status langganan, industri bisnis, atau konfigurasi tenant. Stockara dapat menonaktifkan akses jika ditemukan penyalahgunaan, pelanggaran hukum, atau aktivitas yang membahayakan sistem dan pengguna lain.',
    ],
  },
  {
    title: 'Penggunaan layanan',
    body: [
      'Kamu dapat menggunakan Stockara untuk operasional bisnis yang sah, termasuk mencatat produk, transaksi, stok, pelanggan, laporan, integrasi channel, dan konfigurasi AI customer service.',
      'Kamu tidak boleh menjual ulang akses tanpa izin, membongkar sistem, mengganggu infrastruktur, mencoba mengakses data tenant lain, menggunakan layanan untuk aktivitas ilegal, atau mengirim konten yang merugikan pihak lain.',
    ],
  },
  {
    title: 'Data bisnis dan integrasi',
    body: [
      'Data produk, stok, transaksi, pelanggan, channel, WhatsApp, marketplace, website, dan konfigurasi AI adalah milik tenant masing-masing. Stockara memproses data tersebut untuk menjalankan fitur yang kamu aktifkan.',
      'Jika kamu menghubungkan layanan pihak ketiga seperti WhatsApp gateway, marketplace, payment, website, atau tools integrasi, kamu juga tunduk pada ketentuan masing-masing penyedia layanan tersebut.',
    ],
  },
  {
    title: 'Pembayaran dan langganan',
    body: [
      'Paket Stockara dapat berupa trial, Standard, Plus, Max, atau paket lain yang tersedia. Selama pembayaran masih manual, aktivasi dan perubahan paket diproses oleh tim Stockara setelah konfirmasi pembayaran diterima.',
      'Harga, batas penggunaan, fitur paket, dan kebijakan langganan dapat diperbarui. Jika ada perubahan penting, Stockara akan mengupayakan pemberitahuan melalui website, dashboard, WhatsApp, atau email.',
    ],
  },
  {
    title: 'AI, otomasi, dan hasil sistem',
    body: [
      'Fitur AI membantu membaca data dan memberi respons otomatis, tetapi hasilnya tetap perlu diawasi oleh owner atau admin bisnis. Kamu bertanggung jawab memastikan data produk, stok, harga, prompt, dan integrasi sudah benar.',
      'Stockara tidak menjamin seluruh output AI selalu sempurna. Untuk keputusan penting seperti pembayaran, perubahan stok besar, atau komunikasi sensitif, lakukan pengecekan ulang.',
    ],
  },
  {
    title: 'Batas tanggung jawab',
    body: [
      'Stockara disediakan sebagaimana adanya dan sebagaimana tersedia. Kami berusaha menjaga layanan stabil, aman, dan akurat, tetapi tidak menjamin layanan selalu bebas gangguan, bug, keterlambatan integrasi pihak ketiga, atau kehilangan koneksi.',
      'Sepanjang diizinkan hukum yang berlaku, Stockara tidak bertanggung jawab atas kerugian tidak langsung seperti kehilangan profit, gangguan operasional, kehilangan peluang, atau kesalahan data yang berasal dari input pengguna atau layanan pihak ketiga.',
    ],
  },
  {
    title: 'Perubahan ketentuan',
    body: [
      'Kami dapat memperbarui Syarat & Ketentuan ini agar tetap sesuai dengan perkembangan produk, regulasi, keamanan, dan cara kerja layanan. Versi terbaru akan ditampilkan di halaman ini.',
      'Dengan terus menggunakan Stockara setelah perubahan berlaku, kamu dianggap menerima ketentuan yang diperbarui.',
    ],
  },
];

const privacySections = [
  {
    title: 'Data yang kami proses',
    body: [
      'Stockara memproses data yang kamu berikan saat membuat akun dan memakai layanan, seperti nama, email, nomor telepon, data perusahaan, produk, stok, transaksi, pelanggan, supplier, laporan, konfigurasi AI, serta data integrasi yang kamu hubungkan.',
      'Kami juga dapat memproses data teknis seperti alamat IP, browser, perangkat, waktu akses, log penggunaan, dan cookie untuk menjaga keamanan, performa, serta pengalaman penggunaan.',
    ],
  },
  {
    title: 'Cara kami menggunakan data',
    body: [
      'Data digunakan untuk menjalankan layanan Stockara: autentikasi akun, dashboard, inventori, kasir, laporan, channel manager, AI customer service, AI asisten owner, support pelanggan, keamanan, dan peningkatan fitur.',
      'Kami dapat menggunakan data agregat atau anonim untuk memahami performa sistem dan kebutuhan produk. Data tenant yang dapat mengidentifikasi bisnis atau pelanggan tidak dijual ke pihak ketiga.',
    ],
  },
  {
    title: 'WhatsApp, marketplace, dan website customer',
    body: [
      'Jika kamu mengaktifkan integrasi WhatsApp atau AI CS, Stockara dapat memproses nomor pengirim, isi pesan, konfigurasi bot, riwayat percakapan, dan data bisnis yang diperlukan agar bot menjawab dengan konteks yang tepat.',
      'Jika kamu menghubungkan marketplace atau website sendiri, Stockara dapat memproses data produk, varian, stok, order, status pembayaran, dan sinkronisasi yang dibutuhkan untuk menjaga data tetap rapi.',
    ],
  },
  {
    title: 'Penyedia layanan pihak ketiga',
    body: [
      'Stockara dapat menggunakan penyedia infrastruktur, database, hosting, WhatsApp gateway, AI provider, analytics, email, atau payment untuk menjalankan layanan. Mereka hanya boleh memproses data sesuai kebutuhan layanan dan kewajiban kerahasiaan.',
      'Ketika kamu memakai integrasi pihak ketiga, penggunaan data juga dapat mengikuti kebijakan penyedia tersebut. Pastikan kamu memahami izin yang diberikan saat menghubungkan akun eksternal.',
    ],
  },
  {
    title: 'Keamanan dan penyimpanan data',
    body: [
      'Kami menerapkan langkah teknis dan operasional untuk menjaga keamanan data, termasuk kontrol akses tenant, autentikasi, pembatasan role, dan pemisahan data antar akun bisnis.',
      'Tidak ada sistem yang sepenuhnya bebas risiko. Karena itu, kamu tetap wajib menjaga kredensial, membatasi akses pengguna internal, dan segera melapor jika menemukan aktivitas yang mencurigakan.',
    ],
  },
  {
    title: 'Penghapusan akun dan retensi data',
    body: [
      'Kamu dapat meminta penghapusan akun atau data tertentu melalui email support. Kami akan memproses permintaan sesuai kemampuan teknis, kewajiban hukum, status transaksi, dan kebutuhan audit yang wajar.',
      'Data yang sudah dianonimkan atau diperlukan untuk kepatuhan, keamanan, pencatatan transaksi, dan penyelesaian sengketa dapat disimpan selama diperlukan.',
    ],
  },
  {
    title: 'Cookie dan analytics',
    body: [
      'Stockara dapat memakai cookie untuk login, preferensi tampilan, keamanan, dan analisis penggunaan. Kamu dapat mengatur cookie dari browser, tetapi beberapa fitur mungkin tidak berjalan normal jika cookie dinonaktifkan.',
    ],
  },
  {
    title: 'Hak pengguna',
    body: [
      'Kamu dapat meminta koreksi, pembaruan, pembatasan, atau penghapusan data tertentu dengan menghubungi tim Stockara. Untuk melindungi keamanan, kami dapat meminta verifikasi identitas sebelum memproses permintaan.',
      'Jika kebijakan ini berubah secara signifikan, kami akan mengupayakan pemberitahuan melalui kanal yang tersedia.',
    ],
  },
];

const pageCopy = {
  terms: {
    eyebrow: 'Legal Stockara',
    title: 'Syarat & Ketentuan',
    intro: 'Ketentuan ini menjelaskan aturan penggunaan Stockara sebagai platform bisnis cloud untuk stok, kasir, laporan, integrasi channel, dan AI customer service.',
    icon: FileText,
    sections: termsSections,
  },
  privacy: {
    eyebrow: 'Privasi & Data',
    title: 'Kebijakan Privasi',
    intro: 'Kebijakan ini menjelaskan bagaimana Stockara mengumpulkan, memakai, menyimpan, dan melindungi data pengguna serta data bisnis tenant.',
    icon: ShieldCheck,
    sections: privacySections,
  },
};

export default function LegalPage({ type = 'terms' }) {
  const copy = pageCopy[type] || pageCopy.terms;
  const Icon = copy.icon;

  return (
    <div className="min-h-screen bg-[#F7F3EC] text-[#081B13]">
      <div className="absolute inset-0 pointer-events-none bg-[linear-gradient(rgba(9,112,73,0.06)_1px,transparent_1px),linear-gradient(90deg,rgba(9,112,73,0.06)_1px,transparent_1px),radial-gradient(circle_at_12%_8%,rgba(16,185,129,0.14),transparent_28%),radial-gradient(circle_at_88%_20%,rgba(9,112,73,0.09),transparent_26%)] bg-[length:44px_44px,44px_44px,auto,auto]" />
      <header className="relative border-b border-emerald-900/10 bg-[#FFF9F1]/85 backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-5">
          <Link to="/" className="flex items-center gap-3 text-sm font-bold text-[#0B6B43]">
            <ArrowLeft size={18} />
            Kembali ke Home
          </Link>
          <img src="/logo-stockara.png" alt="Stockara" className="h-10 w-auto object-contain" />
        </div>
      </header>

      <main className="relative mx-auto max-w-6xl px-5 py-12 lg:py-16">
        <section className="overflow-hidden rounded-[28px] border border-emerald-900/10 bg-[#FFFCF7] shadow-[0_28px_80px_rgba(26,87,51,0.09)]">
          <div className="grid gap-0 lg:grid-cols-[0.9fr_1.1fr]">
            <div className="bg-[radial-gradient(circle_at_top_left,rgba(16,185,129,0.18),transparent_34%),linear-gradient(135deg,#E7F6EF,#FFF7EC)] p-7 sm:p-10">
              <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#0B6B43] text-white">
                <Icon size={23} />
              </div>
              <p className="mt-8 text-xs font-black uppercase tracking-[0.18em] text-[#0B6B43]">{copy.eyebrow}</p>
              <h1 className="mt-3 font-serif text-5xl font-normal leading-[0.95] tracking-tight text-[#081B13] sm:text-6xl">
                {copy.title}
              </h1>
              <p className="mt-5 text-base leading-8 text-slate-600">{copy.intro}</p>
              <div className="mt-8 rounded-2xl border border-emerald-900/10 bg-white/70 p-4">
                <p className="text-xs font-bold uppercase tracking-wide text-slate-500">Terakhir diperbarui</p>
                <p className="mt-1 text-lg font-black text-[#081B13]">{UPDATED_AT}</p>
              </div>
            </div>

            <div className="p-6 sm:p-8 lg:p-10">
              <div className="rounded-2xl border border-emerald-900/10 bg-[#F8F4ED] p-5">
                <div className="flex items-start gap-3">
                  <CheckCircle2 className="mt-0.5 text-[#0B6B43]" size={20} />
                  <p className="text-sm leading-7 text-slate-600">
                    Dokumen ini dibuat untuk memberi gambaran jelas tentang hak, tanggung jawab, dan cara Stockara memproses data. Untuk pertanyaan legal atau privasi, hubungi <a href={`mailto:${SUPPORT_EMAIL}`} className="font-bold text-[#0B6B43]">{SUPPORT_EMAIL}</a>.
                  </p>
                </div>
              </div>

              <div className="mt-7 space-y-5">
                {copy.sections.map((section, index) => (
                  <article key={section.title} className="rounded-2xl border border-emerald-900/10 bg-white p-5 shadow-[0_14px_40px_rgba(26,87,51,0.05)]">
                    <div className="flex items-start gap-4">
                      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-xl bg-emerald-50 text-xs font-black text-[#0B6B43]">
                        {String(index + 1).padStart(2, '0')}
                      </span>
                      <div>
                        <h2 className="font-serif text-3xl font-normal leading-none text-[#081B13]">{section.title}</h2>
                        <div className="mt-3 space-y-3">
                          {section.body.map((paragraph) => (
                            <p key={paragraph} className="text-sm leading-7 text-slate-600">{paragraph}</p>
                          ))}
                        </div>
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="relative border-t border-emerald-900/10 bg-white">
        <div className="mx-auto flex max-w-6xl flex-col gap-3 px-5 py-6 text-sm text-slate-500 sm:flex-row sm:items-center sm:justify-between">
          <p>Copyright 2026 Stockara. Semua hak dilindungi.</p>
          <div className="flex gap-5">
            <Link to="/terms" className="hover:text-[#0B6B43]">Syarat & Ketentuan</Link>
            <Link to="/privacy" className="hover:text-[#0B6B43]">Kebijakan Privasi</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
